export default __webpack_public_path__ + "static/refer-project-mobile-b18c9fba693f7f92c5a0787a885953e1.png";